import React from 'react'

import { useAppDispatch, useAppSelector } from '../redux'

import { TypesType, selectTaskInput, setOpen } from '../../slices/taskInput'

const useTaskInputOpen = (
  task: LocalTask & { table?: any },
  type: TypesType
) => {
  const dispatch = useAppDispatch()

  const { inputState } = useAppSelector(selectTaskInput)

  const key = React.useMemo(() => {
    return `${task.id}--${task.table ?? 0}`
  }, [task.id, task.table])

  const isOpen = React.useMemo(() => {
    if (key in inputState) {
      return inputState[key][type]
    }

    return false
  }, [key, inputState, type])

  const handleClick = React.useCallback(
    (e?: any) => {
      if (e) {
        e.stopPropagation()
      }

      dispatch(setOpen({ key, type, open: true }))
    },
    [dispatch, key, type]
  )

  const handleClose = React.useCallback(() => {
    dispatch(setOpen({ key, type, open: false }))
  }, [dispatch, key, type])

  return { isOpen, handleClick, handleClose }
}

export default useTaskInputOpen
